import { createFileRoute, useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';

import { clientModules } from '@/clientModules';

export const Route = createFileRoute('/logout')({
  component: LogoutPage
});

function LogoutPage() {
  const router = useRouter();

  useEffect(() => {
    if (!clientModules.authentication.LogoutPage) {
      router.history.back();
    }
  }, [router]);

  return clientModules.authentication.LogoutPage ? <clientModules.authentication.LogoutPage /> : null;
}
